<div #wrap>
  <div
    *ngIf="(messageObservable | async) as message"
    class="topbar"
  >
    <div class="topbar__text">{{ message }}</div>
  </div>
</div>
